import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTryhackmeComponent } from './simple-icons-tryhackme.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTryhackmeComponent ],
    exports:      [ SimpleIconsTryhackmeComponent ],
    bootstrap:    []
})
export class SimpleIconsTryhackmeModule {}
